import { type MouseEvent, useState } from 'react';

export const useAnchorEl = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const isOpen = Boolean(anchorEl);

  const onOpenMenu = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };
  const onCloseMenu = () => setAnchorEl(null);

  return {
    isOpen,
    anchorEl,
    onOpenMenu,
    onCloseMenu,
  };
};
